import { IntlShape } from 'react-intl';
import { ContentType } from '../PerformancePortal/Notifications/NotificationsPopover';

const DEFAULT_TRANSLATIONS = {
  cs_perfportal_notifications_add_tmproxy_title:
    "You're now proxy for {tmUsername}",
  cs_perfportal_notifications_delete_tmproxy_title:
    "You're no longer proxy for {tmUsername}",
  cs_perfportal_notifications_add_tmproxy_message:
    "{tmUsername}'s team has been shared with you for coaching.",
  cs_perfportal_notifications_delete_tmproxy_message:
    "You're no longer assigned as a proxy for {tmUsername}. No further action is needed.",
};

export const processNotifLocaleStrings = (
  intl: IntlShape,
  contentType: ContentType,
  stringOrId: string,
  values: {}
) => {
  return intl.formatMessage(
    {
      id: contentType === ContentType.LOCALIZED ? stringOrId : '-',
      defaultMessage:
        contentType === ContentType.LOCALIZED
          ? (DEFAULT_TRANSLATIONS[stringOrId] ?? stringOrId)
          : stringOrId,
    },
    values
  );
};
